import React from 'react';
import { Box } from '@mui/material';
import {
  CONFIRMATION_MESSAGE_READY_FOR_AUDIT,
  CONFIRMATION_MESSAGE_REMOVE_READY_FOR_AUDIT,
  READY_FOR_AUDIT_UNSAVED_CHANGES_WARNING,
} from 'pages/ValuationsAllocation/common/constants/valuations';
import { SetReadyForAuditConfirmationProps } from './types';

const SetReadyForAuditConfirmation = (props: SetReadyForAuditConfirmationProps) => {
  const { currentReadinessStatus, hasUnsavedChanges } = props;
  const message = currentReadinessStatus
    ? CONFIRMATION_MESSAGE_REMOVE_READY_FOR_AUDIT
    : CONFIRMATION_MESSAGE_READY_FOR_AUDIT;
  return (
    <Box display="flex" flexDirection="column" justifyContent="center" alignItems="center">
      <Box display="flex" justifyContent="center" alignItems="center" />
      <div>
        <p>{message}</p>
        {hasUnsavedChanges && (
          <p id="ready-for-audit-unsaved-changes-warning">
            <strong>{READY_FOR_AUDIT_UNSAVED_CHANGES_WARNING}</strong>
          </p>
        )}
      </div>
    </Box>
  );
};

export default SetReadyForAuditConfirmation;
